module.exports = __webpack_public_path__ + "img/icon_phone.d27704d6.png";